var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.0001H5V9.00006H15V11.0001ZM10 6.10352e-05C8.68678 6.10352e-05 7.38642 0.258719 6.17317 0.761266C4.95991 1.26381 3.85752 2.00041 2.92893 2.92899C1.05357 4.80436 0 7.3479 0 10.0001C0 12.6522 1.05357 15.1958 2.92893 17.0711C3.85752 17.9997 4.95991 18.7363 6.17317 19.2389C7.38642 19.7414 8.68678 20.0001 10 20.0001C12.6522 20.0001 15.1957 18.9465 17.0711 17.0711C18.9464 15.1958 20 12.6522 20 10.0001C20 8.68684 19.7413 7.38648 19.2388 6.17323C18.7362 4.95997 17.9997 3.85758 17.0711 2.92899C16.1425 2.00041 15.0401 1.26381 13.8268 0.761266C12.6136 0.258719 11.3132 6.10352e-05 10 6.10352e-05Z",
    fill: "#920000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.b4bb3cf5b3c557c26ec9d44f82214d7a.svg";
export { ForwardRef as ReactComponent };